//
export const CAJA_ALUMNOS = "caja/ALUMNOS"
export const CAJA_ALUMNOS_SUCCESS = "caja/ALUMNOS_SUCCESS"
export const CAJA_ALUMNOS_FAIL = "caja/ALUMNOS_FAIL"

export const CAJA_LINKPAGO = "caja/LINKPAGO"
export const CAJA_LINKPAGO_SUCCESS = "caja/LINKPAGO_SUCCESS"
export const CAJA_LINKPAGO_FAIL = "caja/LINKPAGO_FAIL"

export const CAJA_LINKPAGO_MASIVO = "caja/LINKPAGO_MASIVO"
export const CAJA_LINKPAGO_MASIVO_SUCCESS = "caja/LINKPAGO_MASIVO_SUCCESS"
export const CAJA_LINKPAGO_MASIVO_FAIL = "caja/LINKPAGO_MASIVO_FAIL"

export const CAJA_ESTADOCUENTA = "caja/ESTADOCUENTA"
export const CAJA_ESTADOCUENTA_SUCCESS = "caja/ESTADOCUENTA_SUCCESS"
export const CAJA_ESTADOCUENTA_FAIL = "caja/ESTADOCUENTA_FAIL"

export const CAJA_GET_RECIBOPAGO = "caja/RECIBOPAGO"
export const CAJA_GET_RECIBOPAGO_SUCCESS = "caja/RECIBOPAGO_SUCCESS"
export const CAJA_GET_RECIBOPAGO_FAIL = "caja/RECIBOPAGO_FAIL"

export const CAJA_GET_CONCEPTOSGASTO = "caja/CONCEPTOSGASTO"
export const CAJA_GET_CONCEPTOSGASTO_SUCCESS = "caja/CONCEPTOSGASTO_SUCCESS"
export const CAJA_GET_CONCEPTOSGASTO_FAIL = "caja/CONCEPTOSGASTO_FAIL"

export const CAJA_POST_ABONOACUENTA = "caja/ABONOACUENTA"
export const CAJA_POST_ABONOACUENTA_SUCCESS = "caja/ABONOACUENTA_SUCCESS"
export const CAJA_POST_ABONOACUENTA_FAIL = "caja/ABONOACUENTA_FAIL"

export const CAJA_POST_ENVIORECIBO = "caja/ENVIORECIBO"
export const CAJA_POST_ENVIORECIBO_SUCCESS = "caja/ENVIORECIBO_SUCCESS"
export const CAJA_POST_ENVIORECIBO_FAIL = "caja/ENVIORECIBO_FAIL"

export const CAJA_GET_DESCUENTOSCATALOGO = "caja/GETDESCUENTOSCATALOGO"
export const CAJA_GET_DESCUENTOSCATALOGO_SUCCESS =
  "caja/GETDESCUENTOSCATALOGO_SUCCESS"
export const CAJA_GET_DESCUENTOSCATALOGO_FAIL =
  "caja/GETDESCUENTOSCATALOGO_FAIL"

export const CAJA_GET_DESCUENTOSXIDCUENTA = "caja/GETDESCUENTOSXIDCUENTA"
export const CAJA_GET_DESCUENTOSXIDCUENTA_SUCCESS =
  "caja/GETDESCUENTOSXIDCUENTA_SUCCESS"
export const CAJA_GET_DESCUENTOSXIDCUENTA_FAIL =
  "caja/GETDESCUENTOSXIDCUENTA_FAIL"

export const CAJA_GET_GSEQUIVALENTES = "caja/GSEQUIVALENTES"
export const CAJA_GET_GSEQUIVALENTES_SUCCESS = "caja/GSEQUIVALENTES_SUCCESS"
export const CAJA_GET_GSEQUIVALENTES_FAIL = "caja/GSEQUIVALENTES_FAIL"

export const CAJA_GET_FORMASPAGOSAT = "caja/FORMASPAGOSAT"
export const CAJA_GET_FORMASPAGOSAT_SUCCESS = "caja/FORMASPAGOSAT_SUCCESS"
export const CAJA_GET_FORMASPAGOSAT_FAIL = "caja/FORMASPAGOSAT_FAIL"

export const CAJA_GET_USOSCFDI40 = "caja/USOSCFDI40"
export const CAJA_GET_USOSCFDI40_SUCCESS = "caja/USOSCFDI40_SUCCESS"
export const CAJA_GET_USOSCFDI40_FAIL = "caja/USOSCFDI40_FAIL"

export const CAJA_GET_SERVICIOS = "caja/SERVICIOS"
export const CAJA_GET_SERVICIOS_SUCCESS = "caja/SERVICIOS_SUCCESS"
export const CAJA_GET_SERVICIOS_FAIL = "caja/SERVICIOS_FAIL"

export const CAJA_GET_ULTIMOCARGO = "caja/ULTIMOCARGO"
export const CAJA_GET_ULTIMOCARGO_SUCCESS = "caja/ULTIMOCARGO_SUCCESS"
export const CAJA_GET_ULTIMOCARGO_FAIL = "caja/ULTIMOCARGO_FAIL"

export const CAJA_DEL_IDRELACIONDESCUENTOCARGO =
  "caja/DEL_IDRELACIONDESCUENTOCARGO"
export const CAJA_DEL_IDRELACIONDESCUENTOCARGO_SUCCESS =
  "caja/DEL_IDRELACIONDESCUENTOCARGO_SUCCESS"
export const CAJA_DEL_IDRELACIONDESCUENTOCARGO_FAIL =
  "caja/DEL_IDRELACIONDESCUENTOCARGO_FAIL"

export const CAJA_DEL_OCARGO = "caja/DEL_OCARGO"
export const CAJA_DEL_OCARGO_SUCCESS = "caja/DEL_OCARGO_SUCCESS"
export const CAJA_DEL_OCARGO_FAIL = "caja/DEL_OCARGO_FAIL"

export const CAJA_POST_ADDCARGO = "caja/ADDCARGO"
export const CAJA_POST_ADDCARGO_SUCCESS = "caja/ADDCARGO_SUCCESS"
export const CAJA_POST_ADDCARGO_FAIL = "caja/ADDCARGO_FAIL"

export const CAJA_POST_ADDGASTO = "caja/ADDGASTO"
export const CAJA_POST_ADDGASTO_SUCCESS = "caja/ADDGASTO_SUCCESS"
export const CAJA_POST_ADDGASTO_FAIL = "caja/ADDGASTO_FAIL"

export const CAJA_GET_GASTO = "caja/GASTO"
export const CAJA_GET_GASTO_SUCCESS = "caja/GASTO_SUCCESS"
export const CAJA_GET_GASTO_FAIL = "caja/GASTO_FAIL"

export const CAJA_DEL_GASTO = "caja/DELGASTO"
export const CAJA_DEL_GASTO_SUCCESS = "caja/DELGASTO_SUCCESS"
export const CAJA_DEL_GASTO_FAIL = "caja/DELGASTO_FAIL"

export const CAJA_GET_GASTOS = "caja/GASTOS"
export const CAJA_GET_GASTOS_SUCCESS = "caja/GASTOS_SUCCESS"
export const CAJA_GET_GASTOS_FAIL = "caja/GASTOS_FAIL"

export const CAJA_SET_MESSAGE_SUCCESS = "caja/SET_MESSAGE_SUCCESS"
export const CAJA_UNSET_MESSAGE_SUCCESS = "caja/UNSET_MESSAGE_SUCCESS"

export const CAJA_SET_IDALUMNOSELECTED = "caja/SET_IDALUMNOSELECTED"
export const CAJA_SET_OALUMNOSELECTED = "caja/SET_OALUMNOSELECTED"
export const CAJA_LOGOUT = "caja/LOGOUT"
